// styled like a form-control
import classNames from 'classnames';
import PropTypes from 'prop-types';
import React, { useContext } from 'react';
import ThemeContext from '../../../providers/ThemeProvider';

const DummyInput = ({ controlClass, dataqa, id, isFocused }) => {
  const theme = useContext(ThemeContext);
  const componentClass = classNames(`${controlClass} form-control`, {
    'form-control--focused': isFocused,
  });

  return (
    <>
      <div className={componentClass} data-qa={dataqa} id={id} />
      <style jsx>{`
        .form-control {
          height: 42px;
          border: solid 1px #d4d4d4;
          padding: 10px;
        }
        .form-control--focused {
          border-color: ${theme.colors.inputfocuscolor} !important;
        }
      `}</style>
    </>
  );
};

DummyInput.propTypes = {
  controlClass: PropTypes.string,
  dataqa: PropTypes.string.isRequired,
  id: PropTypes.string.isRequired,
  isFocused: PropTypes.bool,
};

export default DummyInput;
